module.exports = __webpack_public_path__ + "static/media/proactividad.87352811.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/proactividad.svg
// module id = 192
// module chunks = 0